module.exports = __webpack_public_path__ + "img/logo.4827f491.svg";